import { render } from "./TeamMemberCard.vue?vue&type=template&id=b0a49ace"
import script from "./TeamMemberCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMemberCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Team/TeamMemberCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0a49ace"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0a49ace', __exports__)) {
    api.reload('b0a49ace', __exports__)
  }
  
  module.hot.accept("./TeamMemberCard.vue?vue&type=template&id=b0a49ace", () => {
    api.rerender('b0a49ace', render)
  })

}


export default __exports__